// extracted by mini-css-extract-plugin
export var container = "index-module--container--2GuoF";
export var countDown = "index-module--countDown--NdEOB";
export var music = "index-module--music--esQbq";
export var detail = "index-module--detail--eOjTf";
export var flowTip = "index-module--flowTip--Rj8s6";